export default {
  birthDateInvalid:
    "Ungültiges Datum. Sie müssen zwischen 18 und 110 Jahre alt sein (Jahr {{minYear}} bis {{maxYear}})",
  documentDateInvalid:
    "Ungültiges Datum. Das Jahr muss zwischen 2000 und {{maxYear}} liegen",
  maxChars: "Höchstens {{max}} Zeichen erlaubt",
  fieldRequired: "{{field}} ist erforderlich",
  fieldMinChars: "{{field}} muss mindestens {{min}} Zeichen haben",
  fieldMaxChars: "{{field}} darf höchstens {{max}} Zeichen haben",
  fields: {
    firstName: "Vorname",
    lastName: "Nachname",
    taxId: "Steuer-ID",
    companyName: "Firmenname",
    vatNumber: "USt-IdNr.",
    companyTaxId: "Steuernummer des Unternehmens",
    birthDate: "Geburtsdatum",
    birthPlace: "Geburtsort",
    street: "Straße und Hausnummer",
    postalCode: "Postleitzahl",
    city: "Stadt",
    province: "Bundesland / Region",
    country: "Land",
    documentType: "Dokumenttyp",
    documentNumber: "Dokumentnummer",
    documentIssuer: "Ausstellende Behörde",
    documentIssueDate: "Ausstellungsdatum",
    documentExpiryDate: "Ablaufdatum",
    contactPhone: "Telefonnummer",
    contactEmail: "E-Mail",
    pec: "PEC (zertifizierte E-Mail)",
    legalRepName: "Name des gesetzlichen Vertreters",
    accountHolder: "Kontoinhaber",
  },
  invalidEmailFormat: "Ungültiges E-Mail-Format",
  invalidPhoneFormat:
    "Ungültige Telefonnummer. Verwenden Sie das internationale Format mit + Präfix (z. B. +393331234567).",
  invalidNotificationChannel:
    "Wählen Sie WhatsApp oder E-Mail für Buchungsbenachrichtigungen",
  invalidNotificationLanguage: "Wählen Sie eine Benachrichtigungssprache",
  ibanLength: "IBAN muss 15–34 Zeichen haben",
  documentExpiryBeforeIssue:
    "Das Ablaufdatum muss am Ausstellungstag oder danach liegen",
} as const;
